// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Benefits_wrapper__7__SI","container":"Benefits_container__WUPC1","textContainer":"Benefits_textContainer__QNqip"};